import Controller from "./captainInvoice.controller";
import template from "./captainInvoice.html";

const captainInvoice = {
  template,
  controller: Controller,
};

export default captainInvoice;



// WEBPACK FOOTER //
// ./src/pages/captainInvoice/captainInvoice.component.js